import React, { Component } from 'react';
import LeftMenu from './LeftMenu';
import { Drawer, Button } from 'antd';
import './Header.css'
import {Link} from 'gatsby'


class Navbar extends Component {
  state = {
    visible: false
    
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  
  render() {
    return (
      <nav className="menuBar">
        <div className="logo">
          <Link to="/">4IR</Link>
        </div>
        <div className="menuCon">
            <div className="leftMenu">
            <LeftMenu mode="horizontal" />
          </div>
          
          <Button
            className="barsMenu"
            type="primary"
            onClick={this.showDrawer}
          >
            <span className="barsBtn"></span>
          </Button>
          <Drawer
            title="Menu"
            placement="right"
            className="menu_drawer"
            closable={true}
            onClose={this.onClose}
            visible={this.state.visible}
          >
            <LeftMenu mode="inline" />
           
          </Drawer>
        </div>
      </nav>
    );
  }
}

export default Navbar;
